import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BoxIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.61237 1.11615C8.22372 0.961284 7.77561 0.961282 7.38696 1.11615L1.9946 3.26485L4.11084 4.06757L10.1375 1.72388L8.61237 1.11615Z"
		></path>
		<path
			fill="currentColor"
			d="M12.3953 2.6236L6.42506 4.94537L7.37064 5.30404C8.05045 5.5619 8.5 6.21322 8.5 6.94029V14.9663C8.79341 14.9264 9.08191 14.8513 9.35676 14.7409L14.1584 12.8124C14.6718 12.6062 15 12.1627 15 11.675V4.50263H14.9985C15.0152 4.03251 14.7335 3.55531 14.1535 3.32421L12.3953 2.6236Z"
		></path>
		<path
			fill="currentColor"
			d="M3 5.25049V7.25235C3 7.40386 3.0856 7.54236 3.22111 7.61012L4.71056 8.35484C4.84354 8.42133 5 8.32463 5 8.17595V6.00911L6.83866 6.70654C6.93578 6.74337 7 6.83642 7 6.94029V14.8625C6.87907 14.8283 6.75993 14.7878 6.64324 14.7409L1.84163 12.8124C1.32818 12.6062 1 12.1627 1 11.675V4.49187L3 5.25049Z"
		></path>
	</svg>
))
